import React__default from 'react';
import { createPortal } from 'react-dom';
import { useFrameContext } from '../FrameProvider/FrameProvider.mjs';

function FramePortal({
  children,
  destination
}) {
  const {
    area
  } = useFrameContext();
  const fragment = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children);
  const target = destination ? area[destination] : null;
  return target != null && target.current ? /*#__PURE__*/createPortal(fragment, target.current) : fragment;
}

export { FramePortal };
